import React, { FormEvent, useCallback } from "react";
import { Form } from "../../../../packages/ui/form/Form.js";
import { FormRow } from "../../../../packages/ui/form/FormRow.js";
import { Select } from "../../../../packages/ui/form/select/Select.js";
import { useVatReport } from "./VatReportProvider.js";
import { YEAR_OPTIONS } from "../YearSelectorOptions.js";
import { MONTH_OPTIONS } from "../MonthSelectorOptions.js";
import { validateMonth } from "../../../model/accounting/date/validateMonth.js";

/**
 * Displays year and month selector for VAT report.
 */
export const VatReportMonth = () => {
  const { year, month, setYear, setMonth } = useVatReport();

  const handleMonthChange = useCallback(
    (value: string) => {
      setMonth(validateMonth(value));
    },
    [setMonth]
  );

  const handleSubmit = useCallback((event: FormEvent) => {
    event.preventDefault();
  }, []);

  return (
    <div className="period-form">
      <Form onSubmit={handleSubmit} gap="small">
        <FormRow columns={1}>
          <Select value={year} options={YEAR_OPTIONS} onChange={setYear} />
        </FormRow>
        <FormRow columns={1}>
          <Select value={month} options={MONTH_OPTIONS} onChange={handleMonthChange} />
        </FormRow>
      </Form>
    </div>
  );
};
